import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-cost-summary',
  templateUrl: './airdisk-cost-summary.component.html',
  styleUrls: ['./airdisk-cost-summary.component.scss'],
  standalone: false
})
export class AirdiskCostSummaryComponent {
  private destroy$ = new Subject<void>();
  @Input() adbDropDownData: any;
  fleetInfoData: any;
  frictionDrumMaintainance: any;
  fleetSafetyData: any;
  drumBrakeServiceCosts: any;
  csaViolation: any;
  E65: any;
  E70: any;
  E37: any;
  E67: any;
  E68: any;
  E69: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe((option) => {
      if (option) {
        this.isTractor = option == 'Tractor' ? true : false;
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.fleetInfoData$.subscribe((x) => {
      this.fleetInfoData = x;
    });

    this.airdiskService.frictionDrumMaintainance$.subscribe((y) => {
      this.frictionDrumMaintainance = y;
    });

    this.airdiskService.fleetSafetyData$.subscribe((z) => {
      this.fleetSafetyData = z;
    });

    this.airdiskService.drumBrakeServiceCosts$.subscribe((y) => {
      this.drumBrakeServiceCosts = y;
    });

    this.airdiskService.csaViolation$.subscribe((y) => {
      this.csaViolation = y;
    });

    this.airdiskService.adbCostSummary$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data != null) {
        this.costSummaryForm.patchValue({
          adbImpactWithImprovedStoppingDistance: data.adbImpactWithImprovedStoppingDistance || 1,
          initialADBFleetCost: data.initialADBFleetCost || 2500000,
          impactToFleetAccidentCosts: data.impactToFleetAccidentCosts || 150602,
          adbFrictionMileage: data.adbFrictionMileage || 600000,
          noOfPadReplacementsAtTradeIn: data.noOfPadReplacementsAtTradeIn || 1,
          noOfRotarReplacementsAtTradeIn: data.noOfRotarReplacementsAtTradeIn || 0,
          padAndRotarReplacementUnitCost: data.padAndRotarReplacementUnitCost || 870,
          lifecyclePadAndRotarReplacementFleetCosts: data.lifecyclePadAndRotarReplacementFleetCosts || 870000,
          adbBrakeAdjustmentMaintanaceFleetCost: data.adbBrakeAdjustmentMaintanaceFleetCost || 0,
          csaViolationFleetCost: data.csaViolationFleetCost || 0,
          adbRustJackingPadReplacementFleetCost: data.adbRustJackingPadReplacementFleetCost || 0,
          totalAdbUnitCost: data.totalAdbUnitCost.toFixed(2) || 2719.40,
          totalADBFLeetCost: data.totalADBFLeetCost || 2719398,
        });

        if (this.isTractor) {
          this.costSummaryForm.controls['adbImpactWithImprovedStoppingDistance'].setValue(1);
        } else {
          this.costSummaryForm.controls['adbImpactWithImprovedStoppingDistance'].setValue(0);
        }
      }
    });
    this.calculateAndSetSum();
  }

  costSummaryForm = new FormGroup({
    adbImpactWithImprovedStoppingDistance: new FormControl(1, { validators: Validators.required }),
    initialADBFleetCost: new FormControl(2500000, { validators: Validators.required }),
    impactToFleetAccidentCosts: new FormControl(150602, { validators: Validators.required }),
    adbFrictionMileage: new FormControl(600000, { validators: Validators.required }),
    noOfPadReplacementsAtTradeIn: new FormControl(1, { validators: Validators.required }),
    noOfRotarReplacementsAtTradeIn: new FormControl(0, { validators: Validators.required }),
    padAndRotarReplacementUnitCost: new FormControl(870, { validators: Validators.required }),
    lifecyclePadAndRotarReplacementFleetCosts: new FormControl(870000, { validators: Validators.required }),
    adbBrakeAdjustmentMaintanaceFleetCost: new FormControl(0, { validators: Validators.required }),
    csaViolationFleetCost: new FormControl(0, { validators: Validators.required }),
    adbRustJackingPadReplacementFleetCost: new FormControl(0, { validators: Validators.required }),
    totalAdbUnitCost: new FormControl(2719.40, { validators: Validators.required }),
    totalADBFLeetCost: new FormControl(2719398, { validators: Validators.required }),
  });
  get form() {
    return this.costSummaryForm.controls;
  }

  onFormChanges(): void {
    this.costSummaryForm.get('adbImpactWithImprovedStoppingDistance')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {
    const E63 = +this.costSummaryForm.get('adbImpactWithImprovedStoppingDistance')?.value || 0;

    //Fleet Information:
    const E13 = this.fleetInfoData?.fleetSize;
    const E14 = this.fleetInfoData?.totalNumberOfAxlesPerUnit;
    const E15 = this.isTractor ? this.fleetInfoData?.tractorTradeInCycle : this.fleetInfoData?.trailerTradeInCycle;
    const E16 = this.fleetInfoData?.averageAnnualUnitMilage;
    const E17 = this.fleetInfoData?.drumToShoeReplacementFrequency;
    const E18 = this.fleetInfoData?.adbUpCharge;

    const E19 = this.fleetInfoData?.adbResidualValueAtTradeIn;
    const E20 = this.fleetInfoData?.fleetMaintenanceLaborRate;
    const E21 = this.fleetInfoData?.fleetDownTimeRate;

    //Friction / Drum Maintenance:
    const E30 = this.frictionDrumMaintainance?.averageMilageToChangeFriction;
    const E31 = this.frictionDrumMaintainance?.brakeFrictionRequirementAtTradeIn;
    const E40 = this.frictionDrumMaintainance?.drumBreakServiceLabourCost;
    const E32 = this.frictionDrumMaintainance?.drumBreakShoeReplacementUnitCost;
    const E54 = this.frictionDrumMaintainance?.drumBreakReplacementDueToRustJacking;
    const E33 = this.frictionDrumMaintainance?.drumReplacementUnitCost;

    const I34 = 1;
    const I35 = 1;
    const I112 = 0;
    if (this.isTractor) {
      const E34 = E31 === 1 ? I35 : I34;
      const E35 = E17 === 1 ? E34 : E33;
      const E36 = (E14 * 2 * 1 * E20 + E32) * E34 + E33 * E35;
      this.E37 = E36 * E13;
    } else {
      const E34 = Math.floor((E16 * E15) / E30);
      const E35 = Math.floor(E17 === 1 ? E34 : I112);
      const E36 = (E14 * 2 * 1 * E20 + E32) * E34 + E33 * E35;
      this.E37 = E36 * E13;
    }

    //Section 8

    const E41 = this.drumBrakeServiceCosts?.drumBreakServiceAnnualFrequency;

    const E42 = E14 * 2 * E40 * E41 * E20 * E15;

    const E46 = this.csaViolation?.csaViolationsAnnualPercentage;
    const E47 = this.csaViolation?.roadSideCallRateForCSAViolations;

    const E48 = (E46 / 100) * E13;
    const E49 = (E48 * 13) / 100;

    const E43 = E42 * E13;
    const E51 = (E49 * E47 + E49 * E21) * E15;

    const E56 = (E32 + E21 + E14 * 2 * 1 * E20) * E54;

    const E60 = this.E37 + E43 + E51 + E56;
    const E59 = E60 / E13;

    //Section 9
    const E64 = E18 * E13;
    const E66 = E30 * 1.5;
    const E71 = 0;
    const E72 = 0;
    const E73 = 0;

    const E24 = this.fleetSafetyData.annualFleetAccidentRate;
    const E25 = this.fleetSafetyData.noOfRearEndCollisionsDuringLifecycle; //Math.round(E13 * E24 / 100 * 0.228 * E15);
    const E27 = this.fleetSafetyData.lifecycleRearEndCollisionsFleetCost; //E25 * 75301;

    const I66 = Math.floor(E16 * (E15 / E66));
    const I67 = I66 + (E16 * (E15 / E66) - I66 < 0.5 ? 0 : 1);
    this.isTractorCond(E25, E63, E31, I67, I66, E14, E20, E13, E27, E16, E15, E66);


    //Section 10
    const E76 = E64 - E19 * E13 - this.E65 + (this.E70 + E71 + E72 + E73);
    const E75 = E76 / E13;


    this.costSummaryForm.patchValue({
      initialADBFleetCost: Math.round(E64),
      impactToFleetAccidentCosts: Math.round(this.E65),
      adbFrictionMileage: Math.round(E66),
      noOfPadReplacementsAtTradeIn: Math.round(this.E67),
      noOfRotarReplacementsAtTradeIn: Math.round(this.E68),
      padAndRotarReplacementUnitCost: Math.round(this.E69),
      lifecyclePadAndRotarReplacementFleetCosts: Math.round(this.E70),
      adbBrakeAdjustmentMaintanaceFleetCost: Math.round(E71),
      csaViolationFleetCost: Math.round(E72),
      adbRustJackingPadReplacementFleetCost: Math.round(E73),
      totalAdbUnitCost: Number(E75.toFixed(2)),
      totalADBFLeetCost: Math.round(E76),
    });

  }
  isTractorCond(E25, E63, E31, I67, I66, E14, E20, E13, E27, E16, E15, E66) {
    if (this.isTractor) {
      this.E65 = Math.ceil(E25 * (E63 / 100)) * 75301;
      this.E67 = E31 === 1 ? I67 : I66;
      this.E68 = this.E67 > 1 ? Math.floor(this.E67 / 2) : 0;
      this.E69 = this.E67 * (225 * E14 + E14 * 2 * 0.25 * E20) + this.E68 * (375 * E14 * 2 + E14 * 2 * 2 * E20);
      this.E70 = this.E69 * E13;
    } else {
      this.E65 = Math.ceil(E27 * (E63 / 100)) * 63000;
      this.E67 = Math.floor((E16 * E15) / E66);
      this.E68 = this.E67 > 1 ? Math.floor(this.E67 / 2) : 0;
      this.E69 = this.E67 * (225 * E14 + E14 * 2 * 0.25 * E20) + this.E68 * (375 * E14 * 2 + E14 * 2 * 2 * E20);
      this.E70 = this.E69 * E13;
    }
  }

  storeDataOnChange() {
    if (this.costSummaryForm.valid) {
      this.airdiskService.adbCostSummary$.next(this.costSummaryForm.value);
    } else {
      this.costSummaryForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('drumAdbSummary');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('rustMaintainance');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
